import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSubtasksTranlationsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-subtasks-tranlations',
	path: '/secure/admin/subtasks/ViewTranslations!default.jspa',
};
